import type { SagaIterator } from 'redux-saga';
import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './taxLineItemsActions';
import { getLastSyncDate } from './taxLineItemsSelectors';
import { transformResponseToTaxLineItems } from './taxLineItemsTransformers';
import type { TaxLineItemProps } from './taxLineItemsTypes';

const mkTaxLineItemsResourceConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<TaxLineItemProps>();

const mkResourceConfig = () =>
  mkTaxLineItemsResourceConfig({
    resourceName: 'tax-line-items',
    resourceBaseUrl: 'categories/tax-line-items',
    getLastSyncDate,
    transformResponseToResources: transformResponseToTaxLineItems,
    successAction: actions.getTaxLineItemsSuccess,
    failureAction: actions.getTaxLineItemsFailure,
  });

export function* getTaxLineItemsActionWatcher(): SagaIterator {
  const resourceConfig = mkResourceConfig();
  yield takeLeading(
    actions.getTaxLineItems.type,
    resourceSagaUtils.qcsSyncGetResources<TaxLineItemProps>,
    resourceConfig,
  );
}

export default [getTaxLineItemsActionWatcher];
